<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="contact-form-section" v-if="!isScheduled">
          <p class="hf_heading05">Request for a one-on-one Financial Coaching Session</p>
          <div class="form-container">
            <form action="">
                <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group hf_input-container">
                        <label for="name">Name<span>*</span></label>
                        <input type="text" id="fullName" class="form-control hf_customInput" v-model="fullname" maxlength="100" placeholder="Enter your name">
                        <!-- error message -->
                        <p class="errorMessage" v-if="errors['fullname'] && errors['fullname'] !== ''">
                          <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                          {{ errors["fullname"] }}
                        </p> 
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group hf_input-container">
                        <label for="email">Email<span>*</span></label>
                        <input type="email" id="emailAddress" class="form-control hf_customInput" v-model="email_address" maxlength="100" placeholder="Enter your email"/> 
                        <!-- error message -->
                        <p class="errorMessage" v-if="errors['email_address'] && errors['email_address'] !== ''">
                          <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                          {{ errors["email_address"] }}
                        </p>
                      </div>
                    </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group hf_input-container abc">
                      <label for="mobile">Mobile<span class="hf_primary">*</span></label>
                      <div class="country-code-container">
                          <span class="plus-code">+</span>
                          <input type="number" id="countryCode" class="form-control hf_customInput conCode" v-model="country_code" :maxlength = "maxCountryCodeLength"/>
                          <input type="number" id="mobileNumber" class="form-control hf_customInput telNo" v-model="mobile_number" @keypress="isMobileNumber($event)" oninput="javascript: if (this.value.length >this.maxLength) this.value = this.value.slice(0, this.maxLength);" :maxLength = "maxMobileLength" placeholder="Enter your mobile number"/>
                      </div>
                      <!-- error message -->
                      <p class="errorMessage" v-if="errors['mobile_number'] && errors['mobile_number'] !== ''">
                        <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                        {{ errors["mobile_number"] }}
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group hf_input-container">
                      <label for="location">Location<span>*</span></label>
                      <input type="text" id="location" class="form-control hf_customInput" v-model="location" maxlength="50" placeholder="Enter your location">
                      <!-- error message -->
                      <p class="errorMessage" v-if="errors['location'] && errors['location'] !== ''">
                        <span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
                        {{ errors["location"] }}
                      </p> 
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group captcha-div">
                      <VueRecaptcha 
                        sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
                        ref="recaptchaPage"
                        size="invisible"
                        :load-recaptcha-script="true" 
                        @verify="recaptchaVerified" 
                        @expired="resetCaptcha">
                      </VueRecaptcha>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="book-session-container">
                      <div class="form-group hf_input-container login-checkbox">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="isChecked">
                            <label class="form-check-label" for="flexCheckDefault">
                                I give my consent to receive updates and communication from Happyness Factory.
                            </label>
                        </div>
                      </div>
                      <button :disabled="isFormSubmitting" href="javascript:void(0)" type="button" class="btn-primaryNoIcon lg-primarynoIcon btnScheduleSession" v-on:click="executeCaptcha()">{{ !isFormSubmitting ? 'Book a session' : 'Please wait...' }}</button>
                      <p class="hf_caption">We value your privacy. Your data is encrypted and stored according to industry-standard security protocols.</p>
                    </div>
                  </div>
                </div>
            </form>
          </div>
        </div>

        <div class="thankyou-section" v-if="isScheduled">
          <div class="thankyou-container">
            <div class="lottie-box">
              <lottie-player src="/img/thanks-lottie.json" mode="normal" background="transparent" speed="1" style="width: 80px; height: 80px;" autoplay loop></lottie-player>
            </div>
            <p class="hf_heading04">Thank you!</p>
            <p class="hf_bodytext01">One of our financial coaches will review your details and reach out shortly to schedule your one-on-one discussion.</p>
            <p class="hf_heading06">This conversation is designed to help you:</p>
            <div class="flex-section">
              <div class="left-box">
                <img src="img/currencyInr.svg" alt="currencyInr image">
                <p class="hf_bodytext02">Gain clarity on your financial goals</p>
              </div>
              <div class="center-box">
                <img src="img/ranking.svg" alt="ranking image">
                <p class="hf_bodytext02">Understand where you stand today</p>
              </div>
              <div class="right-box">
                <img src="img/binoculars.svg" alt="binoculars image">
                <p class="hf_bodytext02">Explore the right next steps at your own pace</p>
              </div>
            </div>
            <a href="/" type="button" class="btn-primaryNoIcon lg-primarynoIcon">Explore more</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha';
import { watch } from '@vue/runtime-core';
export default {
  props: {
    leadSource: { type:String, default:'' },
    sourceChannel: { type:String, default:'' },
    sourceMedium: { type:String, default:'' },
  },
  components: {
    VueRecaptcha
  },
  data() {
    return {
      fullname: "",
      email_address: "",
      country_code: "91",
      mobile_number: "",
      location: "",
      recaptchaToken:'',
      errors: [],
      isFormSubmitting: false,
      maxCountryCodeLength: 3,
      maxMobileLength: 10,
      isChecked: true,
      isScheduled: false,
    };
  },
  watch: {
    fullname(userName) {
      this.fullname = userName;
      this.errors["fullname"] = '';
      if( !this.validateCharacters(this.fullname) ) // Check is valid entered name
        this.errors["fullname"] = "Please enter valid Name.";
    },
    email_address(emailAddress) {
      this.email_address = emailAddress;
      let isValidEmail = this.validateEmail(emailAddress);
      this.errors["email_address"] = '';
      if (!isValidEmail) // Check is valid entered email
        this.errors["email_address"] = "Please enter valid Email Address.";
    },
    country_code(countryCode) {
      this.country_code = $.trim(countryCode);
      if (countryCode.toString().length > this.maxCountryCodeLength) {
        this.country_code = $.trim(countryCode.toString().slice(0, this.maxCountryCodeLength));
      }
      if (this.country_code.toString().length > 0 && this.country_code.toString().length <= this.maxCountryCodeLength ){
        this.errors["mobile_number"] = '';
        if( this.country_code == 91 ) {
            this.maxMobileLength = 10;
            if( this.mobile_number.toString().length > 0 ) {
              if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
                this.errors["mobile_number"] = "Please enter valid Mobile Number.";
            }
        }
        else{
          this.maxMobileLength = 13;
          // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
          if( this.mobile_number.toString().length > 0 ) {
            if( !this.validateInternationalMobileNumber(this.mobile_number) )
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
        }
      }
      else
        this.errors["mobile_number"] = "Please enter valid Country Code";
    },
    mobile_number(mobileNumber){
      this.mobile_number = $.trim(mobileNumber);
      if( mobileNumber.toString().length > this.maxMobileLength ){
        this.mobile_number = $.trim(mobileNumber.toString().slice(0, this.maxMobileLength));
      }
      if( this.mobile_number.toString().length > 0 && this.country_code.toString().length > 0 ) {
        if( this.country_code == 91 ) {
          this.errors["mobile_number"] = '';
          if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }
        else {
          // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
          this.errors['mobile_number'] = '';
          if( !this.validateInternationalMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }
      }
    },
    location(locationName) {
      this.location = locationName;
      this.errors["location"] = '';
      if( !this.validateCharacters(this.location) ) // Check is valid entered name
        this.errors["location"] = "Please enter valid Name.";
    },
  },
  methods: {
    async isMobileNumber(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    resetCaptcha() {
      this.$refs.recaptchaPage.reset();
      this.recaptchaToken = "";
      this.errors["recaptcha_error"] = "";
    },
    recaptchaVerified(token) {
      console.log("aaa");
      if (token ){
        console.log("1111111");
      this.recaptchaToken = token;
      this.validateBookASessionForm();
      }else{
        console.log("2222222");
      }
    },
    executeCaptcha(){
      console.log("executeCaptcha");
      //execute captcha call here
      //=========================================
      this.$refs.recaptchaPage.execute();
    },
    validateBookASessionForm(){
      console.log("Form Submit");
      var fullName = $.trim(this.fullname);
      var location = $.trim(this.location);
      var emailAddress = $.trim(this.email_address);
      var countryCode = $.trim(this.country_code);
      var mobileNumber = $.trim(this.mobile_number);

      var leadSource = $.trim(this.leadSource);
      var sourceChannel = $.trim(this.sourceChannel);
      var sourceMedium = $.trim(this.sourceMedium);
      // // LET'S VALIDATE FINAL FORM
      if(this.validateCharacters(fullName) && this.validateCharacters(location) && this.validateEmail(emailAddress) && countryCode.toString().length > 0 && ((countryCode == '91' && this.validateMobileNumber(mobileNumber)) || (countryCode !== '91' && this.validateInternationalMobileNumber(mobileNumber))) ){

        this.isFormSubmitting = true;
        // API pending
        let userdata = {
          recaptcha_token: this.recaptchaToken,
          fullname: fullName,
          email: emailAddress,
          country_code: countryCode,
          mobile_number: mobileNumber,
          location: location,
          leadSource: leadSource,
          sourceMedium: sourceMedium,
          sourceChannel: sourceChannel,
        }

        console.log(userdata);
        axios.post('/book-a-session', userdata).then((apiResponse) => {
          // console.log(apiResponse);
          if (apiResponse.hasOwnProperty('data')) {
            if (apiResponse.data.hasOwnProperty('status') && apiResponse.data.status == 1) {
              this.isScheduled = true;
              // Prepare object for Clevertap events
              const [first, last] = fullName.split(' ');
              var firstName = ( first !== undefined ? first.charAt(0).toUpperCase() + first.slice(1) : '' );
              var lastName = ( last !== undefined ? last.charAt(0).toUpperCase()+ last.slice(1) : '' );
              // console.log("firstName :: "+firstName);
              // console.log("lastName :: "+lastName);
              var pageName = window.location.pathname;
              // console.log("isChecked ="+this.isChecked);
              // console.log("pageName ="+pageName);

              // if  consent checkbox is checked then n only push event in clevertap
              //====================================================================
              if(this.isChecked == true){
                clevertap.profile.push({
                  "Site": {
                    "Identity":emailAddress,
                    "Name": fullName,
                    "First Name":firstName,
                    "Last Name":lastName,
                    "Email": emailAddress,
                    "Phone": '+'+countryCode+mobileNumber,
                    "Location": location,
                    "MSG-email": true,
                    "MSG-dndEmail": false
                  }
                });
                clevertap.event.push("Connect With Us",{
                  "Name": fullName,
                  "Email": emailAddress,
                  "page name": pageName,
                  "Source" : "HF"
                });
              //====================================================================
              }
            }
            else if( apiResponse.data.hasOwnProperty('status') && apiResponse.data.status == -2) {
              this.resetCaptcha();
              this.isFormSubmitting = false;
              if( apiResponse.data.hasOwnProperty('field_type') && apiResponse.data.field_type !== '' )
                  this.errors[apiResponse.data.field_type] = apiResponse.data.message;
            }
            else{
              this.resetCaptcha();
              this.isFormSubmitting = false;
              if( apiResponse.data.hasOwnProperty('message') && apiResponse.data.message!=="" )
                this.errors['form_error'] = apiResponse.data.message;
            }
          }
        }).catch(response => {
          console.log(response.data);
          this.isFormSubmitting = false;
        });
      }
      else {
        console.log("Error");
        this.isFormSubmitting = false;
        this.resetCaptcha();

        if (!this.validateCharacters(fullName))
          this.errors["fullname"] = "Please enter valid Name.";
        
        if (!this.validateEmail(emailAddress))
          this.errors["email_address"] = "Please enter valid Email Address.";
        
        if( (countryCode == '91' && !this.validateMobileNumber(mobileNumber)) ||
          (countryCode !== '91' && !this.validateInternationalMobileNumber(mobileNumber)) )
          this.errors["mobile_number"] = "Please enter valid Mobile Number.";

        if (!this.validateCharacters(location))
          this.errors["location"] = "Please enter valid Location.";
      }  // endif form validation
    },
  },
  mounted() {
    // console.log(this.leadSource);
    // console.log(this.sourceChannel);
    // console.log(this.sourceMedium);
  }
};
</script>